/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CalendarIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CalendarIcon({
  children,
  viewPath = "/DesignSystem/Svgs/CalendarIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="CalendarIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-ZdCbUP': alignSelf,'--mt-2-ZdCbUP': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZdCbUP': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZdCbUP': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZdCbUP': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZdCbUP': opacity,'--w-10-ZdCbUP': typeof width === 'number' ? `${width}px` : width,'--h-11-ZdCbUP': typeof height === 'number' ? `${height}px` : height,'--a-7-ZdCbUP': isAnimated ? animation : "none",'--sd-8-ZdCbUP': isAnimated ? strokeDashoffset : 0,'--sd-9-ZdCbUP': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="CalendarIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M24.7 28.1H7.3c-1.9 0-3.4-1.5-3.4-3.4V7.3c0-1.9 1.5-3.4 3.4-3.4h17.3c1.9 0 3.4 1.5 3.4 3.4v17.3c.1 2-1.4 3.5-3.3 3.5zM3.9 10.5h24.2"
 style={{'--f-12-ZdCbUP': fill,'--s-13-ZdCbUP': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}